import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { SecondaryButton } from "../Buttons/components/ActionButton";

export type ResetButtonProps = {
    isDisabled: boolean;
    callback?: () => void;
};

export const RefreshButton: FC<ResetButtonProps> = ({ isDisabled, callback }) => {
    const navigate = useNavigate();
    const defaultCallback = () => navigate(0);

    return (
        <SecondaryButton name="refresh_button" onClick={callback || defaultCallback} disabled={isDisabled}>
            {i18n.t("button.refresh")}
        </SecondaryButton>
    );
};
